import { IShip } from '../../../data/types/ship/ship';
import { getFuelTanks } from './fuel-tanks-size';
import { getCurrentFuelLevel } from './current-fuel-level';

export const getFuelAmountToFillIn = (ship: IShip): number =>
  getFuelTanks(ship) - getCurrentFuelLevel(ship);
